<template>
  <v-card class="primary darken-1">
    <div>
      <v-card-title>Relatórios com dados climatológicos e hidrológicos.</v-card-title>
      <v-card-subtitle>
        <v-icon small>mdi-help-circle-outline</v-icon>
        <span style="font-size: 14px">
        Você pode baixar até 5 relatórios ao mesmo tempo.
      </span>
      </v-card-subtitle>
      <v-card-title>
        <v-row>
          <v-col>
            <span class="subtitle-page">Nome do relatório</span>
            <v-text-field
              v-model="search"
              outlined
              prepend-inner-icon="mdi-magnify"
              label="Digite o nome do relatório para buscar"
              single-line
              hide-details
              clear-icon="mdi-backspace-outline"
              clearable
              item-color="secondary lighten-1"
              color="secondary lighten-1"
            ></v-text-field>
          </v-col>
          <v-spacer v-if="$vuetify.breakpoint.name === 'sm'" />
          <v-col>
            <span class="subtitle-page">Período</span>
            <MonthlyFilter @applyPeriod="applyPeriod($event)" :min="min" :max="max"></MonthlyFilter>
          </v-col>
          <v-spacer v-if="!$vuetify.breakpoint.name === 'xs' || !$vuetify.breakpoint.name === 'sm'" />
        </v-row>
      </v-card-title>
      <v-card v-if="showAnimation" class="mt-3 primary darken-1 elevation-0">
        <div style="height: 300px;">
          <loading-animation @loopComplete="loadAnimationComplete"></loading-animation>
        </div>
      </v-card>
      <v-data-table
        v-show="!showAnimation"
        dense
        id="data-table-reports-data"
        class="primary darken-1 white--text"
        v-model="selected"
        :search="search"
        :headers="headers"
        :items="reports"
        item-key="title"
        hide-default-footer
        :page.sync="page"
        :items-per-page="itemsPerPage"
        @page-count="pageCount = $event"
      >
        <template v-slot:no-data>
          <v-card flat color="primary darken-1">
            <v-card-text>
              <br/>
              <v-icon class="mr-2" color="warning">mdi-alert-circle-outline</v-icon>
              <span class="warning--text">Não há relatórios no período pesquisado.</span>
            </v-card-text>
          </v-card>
        </template>
        <template v-slot:no-results>
          <v-card flat color="primary darken-1">
            <v-card-text>
<!--              <br/>
              <v-icon class="mr-2" color="warning">mdi-alert-circle-outline</v-icon>-->
              <span class="error--text">Não encontrado.</span>
            </v-card-text>
          </v-card>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn text icon v-bind="attrs" v-on="on" @click="donwnloadItem(item)" :loading="item.loadingDownload" :disabled="item.loadingDownload">
              <v-icon color="secondary lighten-1">
                mdi-file-download-outline
              </v-icon>
              </v-btn>
            </template>
            <span>Download</span>
          </v-tooltip>
         <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn text icon @click="viewerItem(item)" v-bind="attrs" v-on="on" :loading="item.loadingViewing" :disabled="item.loadingViewing">
              <v-icon color="secondary lighten-1" >
                mdi-file-eye-outline
              </v-icon>
              </v-btn>
            </template>
            <span>Pré-Visualizar</span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.id`]="{ item }">
          <v-checkbox color="secondary lighten-1" :disabled="disabledCheck(item)" @click="preProcess(item)"></v-checkbox>
        </template>
        <template v-slot:[`item.date`]="{ item }">
          <v-timeline align-top dense class="timeline-table">
            <v-timeline-item color="secondary lighten-1" small fill-dot>
            <span>
              {{ item.date }}
            </span>
            </v-timeline-item>
          </v-timeline>
        </template>
        <template v-slot:[`item.title`]="{ item }">
          <div style="display: flex; align-items: start; justify-content: start;">
            <span>{{ item.title }}</span>
            <v-chip v-if="item.tag === 'new'" class="ml-2" color="rgba(101, 161, 236, 0.2)" label style="display: block;" small>
              <strong style="color: #95A1EC">Novo</strong>
            </v-chip>
          </div>
        </template>
        <template v-slot:[`item.size`]="{ item }">
          <span>{{ bytesToSize(item.size) }}</span>
        </template>
      </v-data-table>
      <div v-if="$vuetify.breakpoint.name === 'xs'" v-show="!showAnimation" class="mt-2 pa-2 mr-2 ml-5" style="align-items: center;justify-content: space-between;font-style: normal;font-weight: normal;font-size: 12px;line-height: 16px;">
        <div>
          <v-btn class="mb-5" style="text-transform: none" @click="donwnloadItems()" :disabled="!this.selected.length > 0" outlined color="secondary lighten-1" :loading="loadingDownloads">
            <v-icon left>mdi-file-download-outline</v-icon>
            Baixar relatórios selecionados
          </v-btn>
        </div>
        <div class="mb-5">Mostrando {{startItem}}-{{endItem}} de {{reports.length}} resultados</div>
        <div style="display: flex; align-items: center;">
          <span class="mr-3">Linhas por página:</span>
          <div style="max-width: 64px;">
            <v-select
              v-model="itemsPerPage"
              :items="itemsPerPageOptions"
              dense
              hide-details
              item-color="secondary lighten-1"
              color="secondary lighten-1"
            ></v-select>
          </div>
          <v-pagination
            class="ml-3 pagination-data elevation-0"
            color="secondary lighten-1"
            v-model="page"
            :length="pageCount"
          ></v-pagination>
        </div>
      </div>
      <div v-else v-show="!showAnimation" class="mt-2 pa-2 mr-2 ml-5" style="display: flex; align-items: center;justify-content: space-between;font-style: normal;font-weight: normal;font-size: 12px;line-height: 16px;">
        <div>
          <v-btn style="text-transform: none" @click="donwnloadItems()" :disabled="!this.selected.length > 0 || loadingDownloads" outlined color="secondary lighten-1" :loading="loadingDownloads">
            <v-icon left>mdi-file-download-outline</v-icon>
            Baixar relatórios selecionados
          </v-btn>
        </div>
        <div>Mostrando {{startItem}}-{{endItem}} de {{reports.length}} resultados</div>
        <div style="display: flex; align-items: center;">
          <span class="mr-3">Linhas por página:</span>
          <div style="max-width: 64px;">
            <v-select
              v-model="itemsPerPage"
              :items="itemsPerPageOptions"
              dense
              hide-details
              item-color="secondary lighten-1"
              color="secondary lighten-1"
            ></v-select>
          </div>
          <v-pagination
            class="ml-3 pagination-data elevation-0"
            color="secondary lighten-1"
            v-model="page"
            :length="pageCount"
          ></v-pagination>
        </div>
      </div>
    </div>
    <div class="text-center">
      <v-dialog v-model="dialog" width="1000" class="primary darken-1">
        <v-card class="primary darken-1 white--text pt-4 px-6" style="border">
          <div class="mb-3" style="width: 100%; display: flex; justify-content: space-between;align-items: center;">
            <h1 v-if="currentSelectedPDF" style="font-weight: bold;font-size: 20px;line-height: 23px;">
              {{ currentSelectedPDF.title }}
            </h1>
            <v-btn class="button-text secondary--text text--lighten-1" text @click="dialog=false">
              <v-icon class="mr-1" size="20">mdi-close-circle-outline</v-icon>
              <span>Fechar</span>
            </v-btn>
          </div>
          <v-card-text>
            <PDFJSViewer v-if="currentSelectedPDF" :path="currentSelectedPDF.url"></PDFJSViewer>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </v-card>
</template>

<script>
import MonthlyFilter from "./MonthlyFilter";
import PDFJSViewer from "./PDFJSViewer";
import moment from "moment";
import LoadingAnimation from "../common/LoadingAnimation";
export default {
  name: "ReportsTable",
  components: {LoadingAnimation, PDFJSViewer, MonthlyFilter},
  data () {
    return {
      min: '',
      max: '',
      showAnimation: false,
      loading: false,
      loadingDownloads: false,
      dialog: false,
      search: '',
      selected: [],
      currentSelected: undefined,
      currentSelectedPDF: undefined,
      page: 1,
      pageCount: undefined,
      itemsPerPage: 10,
      itemsPerPageOptions: [
        //{text: '5', value: 5},
        {text: '10', value: 10},
        {text: '25', value: 25},
        {text: '50', value: 50},
        {text: '100', value: 100},
      ],
      headers: [
        { text: '', value: 'id', align: 'start', sortable: false },
        { text: 'Data da publicação', value: 'date', align: 'start' },
        { text: 'Relatório', value: 'title', align: 'start' },
        { text: 'Tamanho', value: 'size', align: 'center' },
        { text: 'Ações', value: 'actions', align: 'center', sortable: false },
      ],
      reports: [],
    }
  },
  watch: {
    selected(){
      if(this.selected.length > 0) {
        this.disabledCheck(this.currentSelected)
      }
    },
    itemsPerPage(value){
      if(value){
        this.page = 1;
      }
    },
  },
  mounted () {
    this.initialize()
  },
  computed:{
    startItem(){
      return (this.page - 1) * this.itemsPerPage + 1;
    },
    endItem(){
      return this.page * this.itemsPerPage;
    }
  },
  methods: {
    loadAnimationComplete(){
      this.showAnimation = this.loading;
    },
    bytesToSize(bytes) {
      var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
      if (bytes == 0) return '0 Byte';
      var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
      return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
    },
    async initialize () {
      this.showAnimation = true
      this.loading = true
      let nowDate = moment().format('YYYY-MM-DDTHH:mm:ss+0000')
      await this.$store.dispatch("loadReports")
      let reports = await this.$store.getters.reports
      reports = reports.map(function(item) {
        return {
          date: moment(item.createdAt, 'YYYY-MM-DDTHH:mm:ss+0000').format('DD/MM/YYYY'),
          size: item.files[0].size,
          diff: moment(nowDate, 'YYYY-MM-DDTHH:mm:ss+0000').diff(moment(item.createdAt, 'YYYY-MM-DDTHH:mm:ss+0000'), 'hours'),
          tag: moment(nowDate, 'YYYY-MM-DDTHH:mm:ss+0000').diff(moment(item.createdAt, 'YYYY-MM-DDTHH:mm:ss+0000'), 'hours') <= 24 ? 'new': 'old',
          loadingDownload: false,
          loadingViewing: false,
          ...item,
        }
      })
      this.$store.commit('setReportsCopy', reports)
      this.reports = [...reports]
      let dates = this.reports.map(function(item) {
        return moment(item.date, 'DD/MM/YYYY').format('YYYY-MM')
      })
      if(dates){
        this.min = dates[dates.length-1]
        this.max = dates[0]
      }
      this.loading = false
    },
    applyPeriod(period){
      this.showAnimation = true
      this.loading = true
      let reports = this.$store.getters.copy
      let [ date_start, date_end ] = period;
      let holder = []
      if(date_start && date_end && reports){
        for(let item in reports){
          if(moment(reports[item].date, 'DD/MM/YYYY').format('YYYY-MM') >= date_start && moment(reports[item].date, 'DD/MM/YYYY').format('YYYY-MM') <= date_end){ holder.push(reports[item]) }
        }
      }
      this.reports = holder
      this.loading = false
    },
    disabledCheck(item){
      if(this.selected.length > 0){
        if(this.selected.length === 5){
          item = this.selected.find((a) => a.id === item.id)
          if(item){ return false} else { return true }
        } else { return false }
      }
    },
    async donwnloadItem(item){
      item.loadingDownload = true
      await this.$store.dispatch("loadFile", { post_id: item.id, content_id: 287, file_id: item.files[0].id } )
      let response = await this.$store.getters.file
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.download = item.title+'.pdf'
      link.href = url
      link.click()
      item.loadingDownload = false
    },
    async donwnloadItems(){
      this.loadingDownloads = true
      let ids = this.selected.map(function(item) { return item.files[0].id })
      let file_ids = ''
      for (let item in ids){ file_ids = file_ids + ids[item] + ',' }
      file_ids = file_ids.slice(0, -1)
      await this.$store.dispatch("loadFiles", { content_id: 287, file_ids: file_ids } )
      let response = await this.$store.getters.files
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.download = 'relatorios_infohidro'+'.zip'
      link.href = url
      link.click()
      this.loadingDownloads = false
    },
    async viewerItem(item){
      item.loadingViewing = true
      await this.$store.dispatch("loadFile", { post_id: item.id, content_id: 287, file_id: item.files[0].id } )
      let response = await this.$store.getters.file
      let blob = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}));
      this.currentSelectedPDF = { url: blob, title: item.title }
      item.loadingViewing = false
      this.dialog = true
    },
    preProcess(item){
      let duplicated = ''
      if(this.selected.length > 0){ duplicated = this.selected.find((a) => a.id === item.id) }
      if(duplicated){ this.removeItem(item) } else { this.selected.push(item) }
      this.currentSelected = item
    },
    removeItem(item) {
      const index = this.selected.indexOf(item)
      this.selected.splice(index, 1)
    },
  }
}
</script>

<style scoped>
.subtitle-page{
  font-family: Roboto;
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 20px;
}
#data-table-reports-data ::v-deep th{
  border-bottom: 1px solid #D9D9D9 !important;
  padding: 0px 20px !important;
  color: #FFFFFF;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
}

#data-table-reports-data ::v-deep td{
  border-bottom: 1px solid #2D324F !important;
  padding: 0px 20px !important;
  font-style: normal;
  font-weight: 500;
  font-size: 14px !important;
  line-height: 18px;
}

#data-table-reports-data ::v-deep tr:hover{
  background: var(--v-primary-darken2);
}

#data-table-reports-data ::v-deep .v-data-table__wrapper{
  border-bottom: 1px solid #2D324F !important;
}

.timeline-table::before{
  background: #2D324F !important;
}

.pagination-data ::v-deep .v-pagination__navigation{
  background: var(--v-primary-darken1) !important;
  border-width: 2px;
  border-style: solid;
  border-color: white;
}

.pagination-data ::v-deep .v-pagination__item.v-pagination__item--active{
  background: var(--v-secondary-lighten1) !important;
  border-width: 2px;
  border-style: solid;
  border-color: white;
  color: var(--v-primary-darken1) !important;
}

.pagination-data ::v-deep .v-pagination__item{
  background: var(--v-primary-darken1) !important;
  border-width: 2px;
  border-style: solid;
  border-color: white;
}
</style>
